import React from 'react';
import heroThumbOne from '../../assets/images/LAPTOP-1282x881px.png';
/* import heroThumbTwo from '../../assets/images/hero-thumb-2.png'; */
import shapeTwo from '../../assets/images/shape/shape-2.png';
import shapeThree from '../../assets/images/shape/shape-3.png';
import shapeFour from '../../assets/images/shape/shape-4.png';

function HeroHomeOne() {
    return (
        <>
            <section className="appie-hero-area mt-n5 rounded-bottom">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="appie-hero-content">
                                <span>Bienvenido a aftim.app</span>
                                <h1 className="appie-title">Gestiona todo en un solo sistema.</h1>
                                <p>El control de tu empresa en la palma de tu mano.</p>
                                {/* <ul className="text-center">
                                    <li>
                                        <a href="#">
                                            <i className="fab fa-apple" /> Disponible para Mac & ios
                                        </a>
                                    </li>
                                    <li>
                                        <a className="item-2" href="#">
                                            <i className="fab fa-google-play" /> Disponible para
                                            Android
                                        </a>
                                    </li>
                                    <li>
                                        <a className="item-2 mt-2" href="#">
                                            <i className="fab fa-microsoft" /> Disponible para
                                            Windows
                                        </a>
                                    </li>
                                </ul> */}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="appie-hero-thumb mt-3">
                                <div
                                    className="thumb wow animated fadeInUp"
                                    data-wow-duration="2000ms"
                                    data-wow-delay="200ms"
                                >
                                    <img className="img-fluid w-75" src={heroThumbOne} alt="" />
                                </div>
                                {/* <div
                                    className="thumb-2 wow animated fadeInRight"
                                    data-wow-duration="2000ms"
                                    data-wow-delay="600ms"
                                >
                                    <img src={heroThumbOne} alt="" />
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="hero-shape-1">
                    <img src={shapeTwo} alt="" />
                </div>
                <div className="hero-shape-2">
                    <img src={shapeThree} alt="" />
                </div>
                <div className="hero-shape-3">
                    <img src={shapeFour} alt="" />
                </div>
            </section>
        </>
    );
}

export default HeroHomeOne;
